module.exports = __webpack_public_path__ + "static/media/noResult.d7351e58.png";